import { Component } from '@angular/core'
import { Routes } from '@angular/router'


@Component({
  selector: 'pages',
  template: `
        <router-outlet></router-outlet>
    `,
})
export class Pages {}



// WEBPACK FOOTER //
// ./src/app/pages/pages.component.ts